import './BetbookPostEditorBet.less';

import clsx from 'clsx';
import React from 'react';
import { dispatch } from 'nike-re-framejs';

import { clearTitleSuggestion, loadTitleSuggestion } from '../handlers';

import RadioButton from '../../forms/RadioButton';
import BetbookPostEditorDate from './BetbookPostEditorDate';
import { SportIconNui } from '../../../icons/SportIconNui';

const BetbookPostEditorBet = ({ bet, step, selectedBet, setSelectedBet }) => {
    const { betId, betSelection, betSelectionCode, market, matchExpirationDate, odds, opponents, sportId } = bet;
    const { tournament } = bet;
    const active = selectedBet?.betId === betId && selectedBet?.betSelectionCode === betSelectionCode;
    const opponent1 = opponents[0];
    const opponent2 = opponents[1] || null;

    function handleRadioClick(e, bet) {
        e.preventDefault();
        if (active) {
            setSelectedBet(null);
            dispatch(clearTitleSuggestion);
        } else {
            setSelectedBet(bet);
            dispatch(loadTitleSuggestion(betId, betSelectionCode));
        }
    }
    return (
        <div
            className={clsx('betbook-post-editor-bet flex flex-col br-default br-radius-sm pointer px-10 py-10 mb-10', {
                'bg-black-4': active
            })}
            onClick={step === 1 ? e => handleRadioClick(e, bet) : null}
        >
            <div className="flex items-center justify-between full-width">
                <div className="flex overflow-hidden">
                    {step === 1 ? <RadioButton active={active} onClick={e => handleRadioClick(e, bet)} /> : null}
                    <div>
                        <span className="fs-16 text-bold no-wrap">{opponent1}</span>
                        {opponent2 ? (
                            <>
                                <span className="fs-14 text-bold c-black-40 mx-5 no-wrap">vs</span>
                                <span className="fs-16 text-bold no-wrap">{opponent2}</span>
                            </>
                        ) : null}
                    </div>
                </div>
                <div className="flex" data-atid="betbook-post-editor-sport-icon">
                    <SportIconNui sportId={sportId} sizeX="20" sizeY="20" className={`icon-grey`} isFilled={false} />
                </div>
            </div>
            <div className={clsx('flex flex-col mt-10', { 'ml-30': step === 1 })}>
                <BetbookPostEditorDate date={matchExpirationDate} />
                <span className="fs-14 c-black-40 lh-1-5">{tournament}</span>
                <div className="full-width flex justify-between">
                    <div className="flex lh-1-5">
                        <span className="fs-14 c-black-40">{market}:</span>
                        <span className="fs-14 c-black-40 text-extra-bold ml-3">{betSelection}</span>
                    </div>
                    <span className="fs-14 text-extra-bold">{odds}</span>
                </div>
            </div>
        </div>
    );
};

export default BetbookPostEditorBet;
